import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useGetResourceDetails } from '../../../hooks/resources';

import { IResourceFormData } from '../../../interfaces/resources';

import { ResourceDetailsLayout } from '../../layouts/Resources';
import { ResourceDetailsForm } from '../../sub_components/forms/ResourceDetails';

const ResourceSavePage = () => {
    const { resource_id } = useParams();

    const [resourceId, setResourceId] = useState<number | null>(null);

    const [formData, setFormData] = useState<IResourceFormData>({
        id: null,
        category: { value: { label: "", value: "" }, error: "" },
        title: { value: "", error: "" },
        description: { value: "", error: "" },
        url: { value: "", error: "" },
    });

    const { data: resource, isLoading, error } = useGetResourceDetails(resourceId);

    useEffect(() => {
        if (resource_id) {
            setResourceId(Number(resource_id));
        };
    }, [resource_id]);

    return (
        <ResourceDetailsLayout
            title={resourceId ? (resource?.title ?? 'Resource') : 'Create Resource'}
            error={!!error}
        >
            <div className="immersion__common_details__sub_info_container">
                <div className="immersion__common_details__sub_info_view">
                    <div className="immersion__common_details__sub_info__forms_container">
                        <div className="immersion__resource_details__page_view">
                            <div className="immersion__common_details__layout">
                                <div className="immersion__common_details__content">
                                    <ResourceDetailsForm
                                        operation={resourceId ? 'update' : 'create'}
                                        isLoading={isLoading}
                                        resourceData={resource ?? null}
                                        formData={formData}
                                        setFormData={setFormData}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ResourceDetailsLayout>
    );
};

export default ResourceSavePage;